import UpdateBusinessModal from './UpdateBusinessModal';

export default UpdateBusinessModal;